module.exports = __webpack_public_path__ + "static/workers-53f6365050a3f8cd71106bf815ecc7a7.jpg";